export enum TransactionRecoveryLogsStatus {
  FAILED = 'FAILED',
  IN_PROGRESS = 'IN_PROGRESS',
  SETTLED = 'SETTLED',
}
